<template>
  <div
    id="testProductList"
    class="modal fade confirm testProductList"
    :class="{ 'is-open': open }"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <a @click.stop="$emit('close')" class="close">
            <i class="icon-close"></i>
          </a>
          <!-- <h3 class="modal-title">測試商品清單</h3> -->
          <h3 class="modal-title">新版建議書上線注意事項</h3>
        </div>
        <div class="modal-body px_0 py_0 text-sm">
          <!-- -------------------主要區塊start ----------------------->
          <section
            class="segment selectCustomer MainProductPopup__section pb_20 mf-textWrap"
          >
            <template v-if="this.$store.getters.BuTest">
              <p class="fz_12 text-red">
                目前僅開放以下商品進行內部測試，其餘現售商品將待完成驗收確認後陸續開放。
              </p>
              <p class="fz_20">
                已開放111/9前開辦之傳統型現售商品與享倍愛變額萬能壽險供內部測試，其餘現售商品將待完成驗收確認後陸續開放。
              </p>
            </template>
            <template
              v-else-if="
                this.$store.getters.IsBankUser &&
                this.$store.getters.CloseOldinv == '1'
              "
            >
              <p class="fz_20">
                舊版建議書的傳統型商品已停止使用，不再更新商品設定、也無法進行新增、修改、列印、匯入MI、匯入保健等操作
              </p>
            </template>
            <template
              v-else-if="
                this.$store.getters.IsBankUser &&
                this.$store.getters.CloseOldinv != '1'
              "
            >
              <p class="fz_20">
                1.<span style="color: #0033ee; font-weight: bold"
                  >投資型商品</span
                >已上架至新版建議書
              </p>
              <br />
              <p class="fz_20">
                2.舊版建議書<span style="color: #0033ee; font-weight: bold"
                  >投資型商品</span
                >之「新增、修改、列印、匯入行動投保」等相關功能，將於<span
                  style="color: red; font-weight: bold"
                  >113/2/1</span
                >關閉 ，請盡快熟悉新系統的操作使用
              </p>
            </template>
            <template v-else-if="this.$store.getters.CloseOldinv == '1'">
              <p class="fz_20">
                1.舊版建議書已停止使用，不再更新商品設定、也無法進行新增、修改、列印、匯入MI、匯入保健等操作
              </p>
              <br />
              <p class="fz_20">
                2.完整教學教案請至國泰學習網下載，路徑為：國泰學習網>課程>業務人員課程>行銷學院>數位工具>CRM2.0
                【人壽】CRM2.0新建議書系統操作教學
              </p>
            </template>
            <template v-else>
              <p class="fz_20">
                1.<span style="color: #0033ee; font-weight: bold"
                  >投資型商品</span
                >已上架至新版建議書
              </p>
              <br />
              <p class="fz_20">
                2.舊版建議書<span style="color: #0033ee; font-weight: bold"
                  >投資型商品</span
                >之「新增、修改、列印、匯入行動投保」等相關功能，將於<span
                  style="color: red; font-weight: bold"
                  >113/2/1</span
                >關閉
                ，請盡快熟悉新系統的操作使用，或至國泰學習網觀看教學檔案，路徑為：<br />
                國泰學習網>課程>業務人員課程>行銷學院>數位工具>CRM2.0【人壽】CRM2.0新建議書系統操作教學
              </p>
            </template>
            <!-- <table class="testProductionTable table table-bordered">
              <thead>
                <tr>
                  <th>類別</th>
                  <th>主約商品分類</th>
                  <th>商品代號</th>
                  <th>商品中文名稱</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in testProductionList" :key="item.id">
                  <td>{{ item.prod_cat }}</td>
                  <td>{{ item.prod_type }}</td>
                  <td>{{ item.prod_id }}</td>
                  <td>{{ item.prod_name }}</td>
                </tr>
              </tbody>
            </table> -->
          </section>
          <!-- 確定按鈕 -->
          <section
            class="segment selectCustomer MainProductPopup__section pb_0"
          >
            <div class="action text-right px_12">
              <button
                type="submit"
                class="btn btn-primary btn-sm py_5 ml_10"
                @click.stop="$emit('close')"
              >
                確定
              </button>
            </div>
          </section>
          <!-- -------------------主要區塊end ----------------------->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    open: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      ready: false,
    };
  },
  created() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.testProductList {
  .segment {
    padding: 10px 40px 10px;
    margin-top: 0;
    margin-bottom: 10px;
    border-radius: 0;
  }
}
.testProductionTable {
  max-width: 765px;
  tr > th:nth-of-type(1),
  tr > td:nth-of-type(1) {
    width: 10%;
    border: 1px solid #aaa;
    text-align: center;
  }
  tr > th:nth-of-type(2),
  tr > td:nth-of-type(2) {
    width: 27%;
    border: 1px solid #aaa;
    text-align: center;
  }
  tr > th:nth-of-type(3),
  tr > td:nth-of-type(3) {
    width: 10%;
    border: 1px solid #aaa;
    text-align: center;
  }
  tr > th:nth-of-type(4),
  tr > td:nth-of-type(4) {
    width: 48%;
    border: 1px solid #aaa;
    white-space: normal;
  }
}

.subTitle {
  &--blue {
    font-weight: bold;
    color: #0033ee;
  }
  &--red {
    font-weight: bold;
    color: red;
  }
}
</style>
